'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function KWFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-uj1uysak4", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-rk2ps6bb3", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-5zgk1pidq" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-5zgk1pidq", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-uj1uysak4)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-5zgk1pidq" }), /* @__PURE__ */ React.createElement("path", { fill: "#093", d: "M0 0h32v8H0z", mask: "url(#mantine-rk2ps6bb3)" }), /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M0 16h32v8H0z", mask: "url(#mantine-rk2ps6bb3)" }), /* @__PURE__ */ React.createElement("path", { fill: "#272727", d: "M0 0v24l12-8V8z" })))
  );
}

export { KWFlag };
//# sourceMappingURL=KW.mjs.map
